// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8fa4a802","160":"347915e3","208":"384ccdbe","293":"0706ed0d","453":"c994b90f","516":"d4330ae4","519":"e422975f","917":"d3f88d4b","946":"64f30515"}[chunkId] + ".chunk.js";
};